import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import api from '../api/client';

interface SettingsData {
  usd_rate: string;
  markup_percent: string;
  shop_name: string;
  shop_address: string;
  shop_phone: string;
  receipt_footer: string;
}

const EMPTY: SettingsData = {
  usd_rate: '',
  markup_percent: '',
  shop_name: '',
  shop_address: '',
  shop_phone: '',
  receipt_footer: '',
};

export const Settings: React.FC = () => {
  const [data, setData] = useState<SettingsData>(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.get('/settings/').then((res) => {
      setData({ ...EMPTY, ...res.data });
      setLoading(false);
    });
  }, []);

  const update = (key: keyof SettingsData) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setData((d) => ({ ...d, [key]: e.target.value }));

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setMsg('');
    try {
      await api.put('/settings/1/', data);
      setMsg('Saqlandi ✓');
    } catch {
      setMsg('Saqlashda xato');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center py-12 text-gray-500">Yuklanmoqda...</div>;

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Global sozlamalar</h1>

      <form onSubmit={save} className="card space-y-5">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="label">Dollar kursi (UZS)</label>
            <input type="number" step="0.01" value={data.usd_rate} onChange={update('usd_rate')} className="input" />
          </div>
          <div>
            <label className="label">Ustama foizi (%)</label>
            <input type="number" step="0.01" value={data.markup_percent} onChange={update('markup_percent')} className="input" />
          </div>
        </div>

        <div>
          <label className="label">Platforma nomi (chek)</label>
          <input value={data.shop_name} onChange={update('shop_name')} className="input" />
        </div>
        <div>
          <label className="label">Manzil</label>
          <input value={data.shop_address} onChange={update('shop_address')} className="input" />
        </div>
        <div>
          <label className="label">Telefon</label>
          <input value={data.shop_phone} onChange={update('shop_phone')} className="input" />
        </div>
        <div>
          <label className="label">Chek pastki matni</label>
          <textarea value={data.receipt_footer} onChange={update('receipt_footer')} rows={3} className="input" />
        </div>

        <div className="flex items-center gap-4">
          <button type="submit" disabled={saving} className="btn btn-primary flex items-center gap-2">
            <Save className="w-4 h-4" /> {saving ? 'Saqlanmoqda...' : 'Saqlash'}
          </button>
          {msg && <span className="text-sm text-gray-600">{msg}</span>}
        </div>
      </form>
    </div>
  );
};
